// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// PWA : enregistre le service worker (rend l'app installable)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker").catch(() => {})
  })
}
